import React, { useState } from 'react';
import { Box, Container, IconButton, InputBase, Paper, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { CloseOutlined, FilterListOutlined, SearchOutlined } from '@mui/icons-material';
import { tokens } from 'theme/tokens';


const Searchbar = ({
  searchType,
  isAdvanceSearchDialogOpen,
  children,
  searchKey,
  searchParameters,
  fnSearchMenuHandler,
  fnOnSearchHandler,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const RootContainer = styled(Paper)(() => ({
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    marginBottom: 0,
  }));

  const CustomInputBase = styled(InputBase)(() => ({
    marginLeft: 1,
    flex: 1,
  }));

  const [isCloseButtonVisible, setCloseButtonVisibility] = useState(false);

  const handleDataChange = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;
    if (value.length !== 0) {
      const param = {};
      param[`${name}`] = value.trim();
      Object.assign(searchParameters, param);
      setCloseButtonVisibility(true);
    } else {
      setCloseButtonVisibility(false);
    }
  };

  const handleSearch = (evt) => {
    fnOnSearchHandler(searchParameters);
  };

  const clearSearchField = (evt) => {
    searchParameters = Object.entries(searchParameters).filter(item => item['key'] = evt.target.name);
    setCloseButtonVisibility(false);
    // We need to clear this filtered searchOption from the searchParameters and input box.
    Array.from(document.querySelectorAll('input')).forEach(input => {
      if (input.name === 'name') //true
        input.value = null;
    });
    fnOnSearchHandler(searchParameters);
  };

  return (
    <Box>
      <RootContainer >
        {searchType === 'ADVANCED' ?
          <IconButton aria-label='menu' onClick={fnSearchMenuHandler} size="large">
            <FilterListOutlined />
          </IconButton> : null}
        <CustomInputBase
          label={searchKey}
          placeholder='Search'
          inputProps={{ 'aria-label': 'search orders' }}
          name={searchKey}
          onChange={evt => handleDataChange(evt)}
          disabled={searchType === 'ADVANCED'}
          endAdornment={isCloseButtonVisible ?
            <IconButton name={searchKey} onClick={(evt) => clearSearchField(evt)} size="large">
              <CloseOutlined fontSize='small' />
            </IconButton> : null
          }
        />
        <IconButton color='primary' aria-label='search' onClick={handleSearch} size="large">
          <SearchOutlined />
        </IconButton>
        {/* Search History - Recent Search --- Future */}
        {/* <IconButton className={classes.iconButton} aria-label='history'>
          <HistoryOutlined />
        </IconButton> */}
      </RootContainer>
      <Paper
        elevation={3}
        hidden={!isAdvanceSearchDialogOpen}
        style={{
          marginTop: 10,
          position: 'absolute',
          marginLeft: '-10%',
          zIndex: 1000,
        }}
      >
        <Container
          maxWidth='sm'
        >
          <Box mt={1} display={'flex'} justifyContent={'space-between'}>
            <Typography variant='subtitle1' sx={{ color: colors.base.black, fontWeight: 500 }}>Advanced Search</Typography>
            <IconButton size='small' onClick={fnSearchMenuHandler}>
              <CloseOutlined />
            </IconButton>
          </Box>
          <Box m='20px 0 0 0'>
            {children}
          </Box>
        </Container>
      </Paper>
    </Box>
  );
};

export default Searchbar;